import { Report, ReportComponent } from '@/types';

import { apiClient } from '../http';
import { toReportMutationInput } from './resourceMutationPayloads';
import { createSanitizedResourceService, QueryParams } from './resources';

const base = createSanitizedResourceService<
    Report,
    ReturnType<typeof toReportMutationInput>,
    ReturnType<typeof toReportMutationInput>
>('/api/reports', toReportMutationInput, toReportMutationInput);

export const reportService = {
    ...base,
    createComponent: (reportId: string, input: Partial<ReportComponent>) =>
        apiClient.post<Report, Partial<ReportComponent>>(`/api/reports/${reportId}/components`, input),
    list: <TParams extends QueryParams = QueryParams>(params?: TParams) => base.list(params),
    setArchived: (id: string, archived: boolean) => base.update(id, { archived }),
    setFavorite: (id: string, favorited: boolean) => base.update(id, { favorited }),
    setLocked: (id: string, locked: boolean) => base.update(id, { locked }),
};
